import { useState, useEffect } from 'react';
import apiClient, { Location, Template, PresetData } from '@/api/apiClient';

interface DataLoaderState {
  locations: Location[] | null;
  templates: Template[] | null;
  presets: PresetData | null;
  loading: boolean;
  error: string | null;
}

export function useDataLoader() {
  const [state, setState] = useState<DataLoaderState>({
    locations: null,
    templates: null,
    presets: null,
    loading: true,
    error: null
  });

  const loadAll = async () => {
    try {
      setState(prev => ({ ...prev, loading: true, error: null }));

      const [locations, templates, presets] = await Promise.all([
        apiClient.getLocations(),
        apiClient.getTemplates(),
        apiClient.getPresets()
      ]);

      setState({
        locations,
        templates,
        presets,
        loading: false,
        error: null
      });
    } catch (error) {
      console.error('[DataLoader] Failed to load data:', error);
      setState(prev => ({
        ...prev,
        loading: false,
        error: error instanceof Error ? error.message : 'Failed to load data'
      }));
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  return { ...state, reload: loadAll };
}
